/* X-All rail. The track is a native scroll-snap scroller and works untouched
   with no JavaScript; this adds the arrow paging (edge-disabled) and, in
   `center` mode, marks the centered child so the reviews rail can dim its
   neighbours. Ported from Rail/RailNav in the design project; the design's
   infinite clone loop is deliberately not ported (map deviation: cloned DOM
   duplicates content for assistive tech).

   Markup contract:
   <xall-rail [center]>
     … <div class="x-rl …">children</div> …
     … <button data-x-rail-prev> / <button data-x-rail-next> (optional) …
   </xall-rail> */

/* IIFE with an early return (the shop-all pattern): several sections script-tag
   this file, and a second execution of a top-level class declaration is a
   SyntaxError before any guard can run — the homepage double-loaded it from
   the featured and reviews bands (found 2026-09-04). */
(() => {
if (customElements.get('xall-rail')) return;
class XallRail extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.x-rl');
    if (!this.track) return;
    this.prev = this.querySelector('[data-x-rail-prev]');
    this.next = this.querySelector('[data-x-rail-next]');
    this.centering = this.hasAttribute('center');
    this.sync = this.sync.bind(this);
    this.onScroll = this.onScroll.bind(this);

    if (this.prev) this.prev.addEventListener('click', () => this.by(-1));
    if (this.next) this.next.addEventListener('click', () => this.by(1));
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.sync);

    // children can lay out async (fonts, images): poll until scrollable, then settle
    let polls = 0;
    this.poller = setInterval(() => {
      this.sync();
      polls += 1;
      if (this.track.scrollWidth > this.track.clientWidth || polls > 24) clearInterval(this.poller);
    }, 250);
    this.sync();
  }

  disconnectedCallback() {
    if (!this.track) return;
    this.track.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.sync);
    clearInterval(this.poller);
    clearTimeout(this.debounce);
  }

  onScroll() {
    clearTimeout(this.debounce);
    this.debounce = setTimeout(this.sync, 80);
  }

  by(dir) {
    const g = this.track;
    // center mode pages one card; plain mode pages one viewport
    const gap = parseFloat(getComputedStyle(g).columnGap) || 20;
    const step = this.centering && g.children.length
      ? g.children[0].getBoundingClientRect().width + gap
      : g.clientWidth;
    g.scrollBy({ left: step * dir, behavior: 'smooth' });
  }

  sync() {
    const g = this.track;
    const max = g.scrollWidth - g.clientWidth - 2;
    if (this.prev) this.prev.disabled = g.scrollLeft <= 2;
    if (this.next) this.next.disabled = g.scrollLeft >= max;
    if (!this.centering) return;
    const rect = g.getBoundingClientRect();
    const mid = rect.left + rect.width / 2;
    let best = null;
    let bestDist = Infinity;
    Array.from(g.children).forEach((c) => {
      const b = c.getBoundingClientRect();
      const d = Math.abs(b.left + b.width / 2 - mid);
      if (d < bestDist) { bestDist = d; best = c; }
    });
    Array.from(g.children).forEach((c) => {
      const card = c.classList.contains('x-quote') ? c : c.querySelector('.x-quote');
      if (card) card.classList.toggle('x-on', c === best);
    });
  }
}

customElements.define('xall-rail', XallRail);
})();
